import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { firstValueFrom, take } from 'rxjs';
import { collection, FBaseService } from '../services/firebase/f-base.service';
import { StorageItems } from '../constants/storage-items.constants';

export const authGuard = async () => {
  const authService = inject(AuthService);
  const fbService = inject(FBaseService);
  const router = inject(Router);

  let firebaseUser: any;
  let user: any;
  try {
    firebaseUser = await firstValueFrom(authService.currentUser());

    if (!firebaseUser || !firebaseUser.uid) {
      localStorage.removeItem(StorageItems.USERID);
      router.navigateByUrl('login');
      return false;
    }

    user = await firstValueFrom(fbService.getById(collection.users, firebaseUser.uid));
    localStorage.setItem(StorageItems.USERID, firebaseUser.uid);

    if (!user) {
      localStorage.removeItem(StorageItems.USERID);
      router.navigateByUrl('login');
      return false;
    }

    return true;

  } catch (error: any) {
    console.error('Authentication error:', error);
    await authService.logout();
    localStorage.removeItem(StorageItems.USERID);
    return router.navigateByUrl('login');
  }
};
